module.exports = __webpack_public_path__ + "img/TeamComic_058.15d081cc.png";